import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertListService, ApiService, QueryStringService} from '@xref/ngx';
import {AuthService} from '../../services/auth/auth.service';
import {EmployerOverviewService} from '../../services/employer-overview/employer-overview.service';
import {OauthService} from '../../services/oauth/oauth.service';
import {JwtHelperService} from '@auth0/angular-jwt';
import * as Cookies from 'js-cookie';
import constants from 'src/app/shared/constants';
import {environment} from 'src/environments/environment';
import {IdService} from "../../services/id/id.service";

@Component({
    selector: 'xlog-oauth-open-api',
    templateUrl: './oauth-open-api.component.pug',
    styleUrls: ['./oauth-open-api.component.scss'],
    standalone: false
})
export class OauthOpenApiComponent implements OnInit {
    loaded = false;

    clientId: number;
    state: string;

    partnerLogoUrl = '';
    partnerName = '';

    constructor(
        private api: ApiService,
        private oauth: OauthService,
        public employerOverview: EmployerOverviewService,
        private qString: QueryStringService,
        private alertList: AlertListService,
        private route: ActivatedRoute,
        private router: Router,
        public auth: AuthService,
        public id: IdService,
        private jwtHelper: JwtHelperService
    ) {}

    ngOnInit() {
        this.route.params.subscribe((params: any) => {
            this.clientId = params.clientId;
        });

        this.state = this.qString.getParam('state');

        if (this.id.ent_9105) {
            this.id.getAuthToken();
        }

        this.setRegionalUrl();

        this.getEmployerOverview();
    }

    setRegionalUrl() {
        const token = this.jwtHelper.decodeToken(this.id.ent_9105 ? sessionStorage.getItem(constants.AUTH_TOKEN)
            : Cookies.get(constants.AUTH_TOKEN));

        if (token && token.hasOwnProperty('region')) {
            // Regional url for api-app
            this.api.setRegionalUrl(token.region, environment.API);

            // Regional url for auth api
            this.auth.setRegionalUrl(token.region);
        }
    }

    connectOpenApi() {
        this.loaded = false;

        this.oauth.connectOpenApi(this.clientId, this.state)
            .subscribe(
                this.openApiConnectSuccess,
                this.openApiConnectFailed
            );
    }

    private getEmployerOverview() {
        const success = () => {
            this.loaded = true;

            // If Open API is not active redirect user to app root
            const openApiDetails = this.employerOverview.data.open_api.find(obj => obj.client_id === this.clientId);
            if (!openApiDetails.active) {
                this.alertList.append([{
                    messageKey: 'oauth.openApi.alerts.openApiNotActive',
                    type: 'danger',
                    timeout: 0,
                    keepOnRouteChange: true
                }]);
                this.router.navigate(['/']);
            } else if (openApiDetails.authenticated) {
                // If user has already authenticated against Open API get return URL and redirect user
                this.connectOpenApi();
            }

            this.partnerLogoUrl = `${openApiDetails.url_logo}`;
            this.partnerName = `${openApiDetails.partner_name}`;
        };

        const error = () => {
            this.alertList.append([{
                messageKey: 'alerts.generic.error',
                type: 'danger',
                timeout: 0,
                keepOnRouteChange: true
            }]);

            this.router.navigate(['/']);
        };
        this.employerOverview.getEmployerOverview(success, error);
    }

    private openApiConnectSuccess = (res: any) => {
        let returnUrl = `${res.url_redirect}?code=${res.client_authorization_code}`;
        if (returnUrl.includes("smartrecruiters/client_credentials")) {
            const companyId: number = this.employerOverview.data.company_id;
            returnUrl = `${res.url_redirect}?companyId=${companyId}`;
        }

        // Only attach state if provided
        if (res.state) returnUrl += `&state=${res.state}`;

        this.oauth.redirect(returnUrl);
    };

    private openApiConnectFailed = (error: any) => {
        this.loaded = true;

        // Show error for failed connection
        this.handleConnectError(error.status);
    };

    private handleConnectError(status: number) {
        switch (status) {
            case 404:
                this.alertList.append([{ messageKey: 'oauth.openApi.alerts.partnerDoesNotExist', type: 'danger' }]);
                break;
            case 403:
                this.alertList.append([{ messageKey: 'oauth.openApi.alerts.notConnectedToPartner', type: 'danger' }]);
                break;
            default:
                this.alertList.append([{ messageKey: 'alerts.generic.error', type: 'danger' }]);
                break;
        }
    }
}
